(function(){
  'use strict';
  var q=function(s,c){return (c||document).querySelector(s)};
  var qa=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var body=document.body;
  var fsRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  // Lightweight source context hook. A data/app layer can build on this for Phase 1 TikTok-aware merchandising.
  try {
    var params=new URLSearchParams(window.location.search);
    var source=(params.get('utm_source')||'').toLowerCase();
    if(source.indexOf('tiktok')>-1 || params.has('ttclid') || params.get('fs_tiktok')==='1' || params.has('live_room')) body.classList.add('fs-source-tiktok');
  } catch(e) {}
  var overlay=q('#FsOverlay');
  function openLayer(el){ if(!el)return; el.classList.add('is-open'); if(overlay)overlay.classList.add('is-open'); body.classList.add('fs-lock'); }
  function closeLayers(){ qa('.fs-mobile-drawer,.fs-cart-drawer,.fs-modal').forEach(function(el){el.classList.remove('is-open')}); if(overlay)overlay.classList.remove('is-open'); body.classList.remove('fs-lock'); }
  document.addEventListener('click',function(e){
    var menu=e.target.closest('[data-fs-menu-open]'); if(menu){e.preventDefault();openLayer(q('#FsMobileDrawer'));return;}
    var cart=e.target.closest('[data-fs-cart-open]'); if(cart){e.preventDefault();refreshCart().then(function(){openLayer(q('#FsCartDrawer'))});return;}
    var close=e.target.closest('[data-fs-close]'); if(close){e.preventDefault();closeLayers();return;}
    if(e.target===overlay){closeLayers();return;}
    var search=e.target.closest('[data-fs-search-open]'); if(search){e.preventDefault(); var input=q('.fs-search input'); if(input){input.style.display='block';input.focus();} return;}
    var qv=e.target.closest('[data-fs-qv]'); if(qv){e.preventDefault();openQuickView(qv.closest('.fs-product-card'));return;}
    var qaBtn=e.target.closest('[data-fs-quick-add]'); if(qaBtn){e.preventDefault();quickAdd(qaBtn);return;}
    var remove=e.target.closest('[data-fs-cart-remove]'); if(remove){e.preventDefault();changeCart(remove.getAttribute('data-line'),0);return;}
  });

  // predictive search
  var searchInput=q('[data-fs-search-input]');
  if(searchInput){
    var timer;
    searchInput.addEventListener('input',function(){
      clearTimeout(timer); var term=this.value.trim(); var box=q('[data-fs-search-results]');
      if(!term){if(box)box.classList.remove('is-open');return;}
      timer=setTimeout(function(){
        fetch(fsRoot+'search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product&resources[limit]=5')
          .then(function(r){return r.json()}).then(function(data){
            if(!box)return; var products=(((data||{}).resources||{}).results||{}).products||[];
            if(!products.length){box.innerHTML='<div style="padding:14px">No products found</div>';box.classList.add('is-open');return;}
            box.innerHTML=products.map(function(p){return '<a class="fs-search__result" href="'+p.url+'"><img src="'+(p.image||'')+'" alt=""><span><strong>'+escapeHtml(p.title)+'</strong></span><span>'+formatMoney(p.price)+'</span></a>'}).join('');
            box.classList.add('is-open');
          }).catch(function(){});
      },180);
    });
    document.addEventListener('click',function(e){var box=q('[data-fs-search-results]');if(box && !e.target.closest('.fs-search'))box.classList.remove('is-open')});
  }

  // localization selects
  qa('[data-fs-localization-select]').forEach(function(sel){sel.addEventListener('change',function(){this.form.submit()})});

  // quick view
  function openQuickView(card){
    if(!card)return; var modal=q('#FsQuickViewModal'); if(!modal)return;
    var data=q('.fs-qv-data',card); if(!data)return;
    var img=q('[data-qv-image]',modal), title=q('[data-qv-title]',modal), price=q('[data-qv-price]',modal), select=q('[data-qv-select]',modal), link=q('[data-qv-link]',modal), add=q('[data-qv-add]',modal);
    img.src=data.getAttribute('data-image')||''; img.alt=data.getAttribute('data-title')||'';
    title.textContent=data.getAttribute('data-title')||''; price.textContent=data.getAttribute('data-price')||''; link.href=data.getAttribute('data-url')||'#';
    var variants=[]; try{variants=JSON.parse(data.textContent||'[]')}catch(err){}
    select.innerHTML=''; variants.forEach(function(v){var o=document.createElement('option');o.value=v.id;o.textContent=v.title+(v.available?'':' — Sold out');o.disabled=!v.available;select.appendChild(o)});
    add.onclick=function(){ if(select.value)addVariant(select.value,1); };
    openLayer(modal);
  }

  function quickAdd(btn){
    var id=btn.getAttribute('data-variant-id'); var multiple=btn.getAttribute('data-multiple')==='true';
    if(multiple){openQuickView(btn.closest('.fs-product-card'));return;}
    if(id)addVariant(id,1);
  }
  function addVariant(id,qty){
    fetch(fsRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){if(!r.ok)throw new Error('Unable to add');return r.json()})
      .then(function(){return refreshCart()}).then(function(){closeLayers();openLayer(q('#FsCartDrawer'))})
      .catch(function(err){alert(err.message||'Unable to add item');});
  }
  function changeCart(line,qty){
    fetch(fsRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(line),quantity:Number(qty)})})
      .then(function(){return refreshCart()});
  }
  function refreshCart(){
    return fetch(fsRoot+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){
      qa('[data-fs-cart-count]').forEach(function(el){el.textContent=cart.item_count;el.style.display=cart.item_count?'flex':'none'});
      var drawer=q('#FsCartDrawer'); if(!drawer)return cart; var bodyEl=q('[data-fs-cart-body]',drawer), subtotal=q('[data-fs-cart-subtotal]',drawer), progress=q('[data-fs-shipping-progress]',drawer), ptext=q('[data-fs-shipping-text]',drawer);
      if(!cart.item_count){bodyEl.innerHTML='<div class="fs-cart-empty">Your cart is empty.</div>';}else{
        bodyEl.innerHTML=cart.items.map(function(it,i){return '<div class="fs-cart-item"><img src="'+(it.image||'')+'" alt=""><div><a class="fs-cart-item__title" href="'+it.url+'">'+escapeHtml(it.product_title)+'</a><div style="font-size:11px;color:#806f75">'+escapeHtml(it.variant_title||'')+'</div><div class="fs-cart-item__price">'+formatMoney(it.final_line_price)+'</div></div><button class="fs-cart-item__remove" data-fs-cart-remove data-line="'+(i+1)+'" aria-label="Remove">×</button></div>'}).join('');
      }
      if(subtotal)subtotal.textContent=formatMoney(cart.total_price);
      var threshold=Number(drawer.getAttribute('data-free-shipping')||0)*100;
      if(progress && threshold>0){var pct=Math.min(100,(cart.total_price/threshold)*100);progress.style.width=pct+'%'; if(ptext)ptext.textContent=cart.total_price>=threshold?'You unlocked free shipping.':'Add '+formatMoney(threshold-cart.total_price)+' for free shipping.';}
      return cart;
    });
  }
  function formatMoney(cents){
    try{var code=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';return new Intl.NumberFormat(undefined,{style:'currency',currency:code}).format(Number(cents)/100);}catch(e){return '$'+(Number(cents)/100).toFixed(2)}
  }
  function escapeHtml(str){return String(str||'').replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]})}

  // countdowns - real end time from editor ISO-ish text
  qa('[data-fs-countdown]').forEach(function(el){
    var end=el.getAttribute('data-end'); if(!end)return; var ts=Date.parse(end); if(!ts)return;
    function tick(){var diff=Math.max(0,ts-Date.now()),h=Math.floor(diff/3600000),m=Math.floor((diff%3600000)/60000),s=Math.floor((diff%60000)/1000); var parts=el.querySelectorAll('span'); if(parts[0])parts[0].textContent=String(h).padStart(2,'0'); if(parts[1])parts[1].textContent=String(m).padStart(2,'0'); if(parts[2])parts[2].textContent=String(s).padStart(2,'0'); if(diff<=0)clearInterval(intv)}
    tick(); var intv=setInterval(tick,1000);
  });

  // Mobile PDP sticky buy bar: uses the existing Debut product form, so variants and inventory remain Shopify-native.
  var sticky=q('[data-fs-pdp-sticky]');
  if(sticky){
    var stickyPrice=q('[data-fs-pdp-price]',sticky);
    function syncSticky(){
      var sale=qa('.product__price .price-item--sale').filter(function(el){return getComputedStyle(el).display!=='none'})[0];
      var reg=qa('.product__price .price-item--regular').filter(function(el){return getComputedStyle(el).display!=='none'})[0];
      var source=sale||reg;
      if(source && stickyPrice)stickyPrice.textContent=source.textContent.trim();
      var add=q('[data-add-to-cart]');
      qa('[data-fs-pdp-add],[data-fs-pdp-buy]',sticky).forEach(function(b){b.disabled=add ? (add.disabled || add.getAttribute('aria-disabled')==='true') : true;});
    }
    document.addEventListener('change',function(e){if(e.target.matches('.single-option-selector,[name="id"]'))setTimeout(syncSticky,80)});
    var addSticky=q('[data-fs-pdp-add]',sticky); if(addSticky)addSticky.addEventListener('click',function(){var add=q('[data-add-to-cart]');if(add)add.click()});
    var buySticky=q('[data-fs-pdp-buy]',sticky); if(buySticky)buySticky.addEventListener('click',function(){var buy=q('.shopify-payment-button__button');if(buy){buy.click()}else{var add=q('[data-add-to-cart]');if(add)add.click()}});
    setTimeout(syncSticky,200);
  }

})();
